// extracted by mini-css-extract-plugin
export default {"dignitaries_container":"Dignitaries_dignitaries_container__NvFEM","image_container":"Dignitaries_image_container__Scsc6"};